<template>
  <loader v-if="loading" />
  <div v-else>
    <div class="active-race-container">
      <div class="active-race">
        <div class="active-col info-col">
          <span class="active-race-code">{{ activeRace.race_code }}</span>
          <span class="active-race-location">{{ activeRace.race_location }}</span>
          <span class="active-race-date">{{ raceDate }}</span>
          <span>
            Img:
            <b>{{ activeRace.total_images }}</b>
          </span>
        </div>
        <div class="active-col">
          <img :src="imgPath" :alt="activeRace.race_location" class="active-img">
        </div>
      </div>
      <div class="pilot-statistics" v-if="currentRaceStatistics">
        <template v-for="carStatistics in currentRaceStatistics">
          <card
            class="pilot-card"
            :key="carStatistics.car_number"
            @click="handleCardClick(carStatistics.car_number)"
          >
            <span slot="top-left">{{ getPilot(carStatistics.car_number) }}</span>
            <span slot="top-right" v-if="carStatistics.img" class="d-flex">
              <img
                class="pilot-img"
                :alt="`Number ${carStatistics.car_number}`"
                :src="carStatistics.img"
              />
            </span>
            <template slot="middle" v-for="(value, key) in carStatistics.car_stats">
              <span :key="`${key}-1`">{{ key }}: </span>
              <b :key="`${key}-2`">{{ value }}</b>
            </template>
          </card>
        </template>
      </div>
    </div>
    <toolbar-actions
      :open-stats="showStats"
      :search="search"
      :statistics="statistics"
      @onSearch="handleSearch"
      @onStats="toggleStatisticVisibility"
    />
    <RaceGallery :races="filteredRaces" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/utils/utils'
import { getRaces } from '../../api/races'
// import { getRaceStatistics } from '../../api/statistics'
import Card from './Card';
import Loader from '@/components/Loader';
import RaceGallery from './RaceGallery'
import ToolbarActions from './ToolbarActions';

export default {
  name: 'Dashboard',
  components: {
    Card,
    Loader,
    ToolbarActions,
    RaceGallery
  },
  data() {
    return {
      races: null,
      currentRaceStatistics: null,
      currentPage: 2,
      isSendPagination: true,
      loading: false,
      totalCountRaces: 0,
      search: ''
    }
  },
  computed: {
    ...mapGetters ({
      showStats: 'races/showStats',
    }),
    activeRace() {
      if (!this.races) {
        return {}
      }
      const lastYear = Object.keys(this.races).pop()
      return this.races[lastYear][0]
    },
    filteredRaces() {
      let filtered = {}
      const formatSearch = this.search.toLocaleLowerCase()
      for (let year in this.races) {
        let filretedRaceByYear = this.races[year].filter(race => race?.race_event?.toLocaleLowerCase().includes(formatSearch))
        if (filretedRaceByYear.length) {
          filtered[year] = filretedRaceByYear
        }
      }
      return filtered
    },
    imgPath() {
      return process.env.VUE_APP_BASE_API_PATH + this.activeRace?.track_image
    },
    raceDate() {
      return formatDate(this.activeRace.race_date)
    },
    statistics() {
      const defaultValue = {
        images: 0,
        races: 0,
        seasons: 0,
      }
      for (const year in this.filteredRaces) {
        const currentRaces = this.filteredRaces[year]
        defaultValue.images += currentRaces.reduce((res, { total_images }) => {
          res += total_images
          return res
        }, 0)
        defaultValue.seasons += 1
        defaultValue.races += currentRaces.length
      }
      return defaultValue
    },
  },
  methods: {
    ...mapActions({
      toggleStatisticVisibility: 'races/toggleStatisticVisibility',
    }),
    getImg(number) {
      if ([5, 9, 24, 48].includes(number)) {
        return require(`@/assets/images/${number}.svg`)
      }
      return null
    },
    getPilot(number) {
      switch (number) {
        case '5':
          return 'Larson'
        case '9':
          return 'Elliott'
        case '24':
          return 'Byron'
        case '48':
          return 'Bowman'
        default:
          return 'Pilot'
      }
    },
    handleCardClick(car_number) {
      this.$router.push({
        name: 'race',
        params: { raceId: this.activeRace._id },
        query: { car_number }
      })
    },
    handleSearch(value) {
      this.search = value
    },
    scrollyend() {
      // UNUSED
      if (this.races.length < this.totalCountRaces && this.isSendPagination) {
        this.isSendPagination = false
        getRaces({page: this.currentPage})
          .then(res => {
            this.races.push(...res.data.races)
            this.currentPage++
            this.isSendPagination = true
          })
          .catch(e => console.log(e))
      }
    }
  },
  mounted() {
    this.loading = true
    getRaces({})
      .then(res => {
        this.races = res.data.races
        this.totalCountRaces = res.data.total
        // return getRaceStatistics(this.activeRace._id)
      })
      .then(res => {
        if (!res?.data?.race_stats) {
          return;
        }
        this.currentRaceStatistics = res.data.race_stats.map(el => ({
          ...el,
          img: this.getImg(Number(el.car_number)),
        }))
      })
      .catch(e => console.log(e))
      .finally(() => this.loading = false)
  }
}
</script>


<style lang="scss" scoped>
.active-race-container {
  display: flex;
  gap: 10px;
  padding: 8px 20px 10px;
  background-image: url('~@/assets/images/Race.svg');
  background-size: contain;
}

.info-col {
  gap: 6px;
}

.active-race {
  display: flex;
  gap: 8px;
  margin-left: 44px;
  font-weight: 500;
  line-height: 24px;
}

.active-race-code {
  font-size: 24px;
  line-height: 32px;
}

.active-race-location {
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
}

.active-race-date {
  font-size: 14px;
}

.active-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 264px;

  * {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.active-img {
  width: 240px;
  height: 96px;
}

.pilot-statistics {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  flex: 1;
}

.pilot-card {
  max-width: 300px;
  padding: 8px 12px 12px;
  flex-basis: 25%;
  box-shadow: none!important;
  border: 1px solid var(--v-blue-lighten-3);
}

.pilot-img {
  max-height: 24px;
  align-self: end;
  margin-top: auto;
}
</style>
